import React, { Component } from 'react'
import {
  Layout,
  Button,
  Divider,
  Row,
  Column,
  Text,
  Topbar,
  styleguide,
} from 'styleguide'
import Scoops from 'api'
import mixpanel from 'mixpanel-browser'
import { Sections, Ship } from './components'
import { css } from 'react-emotion'

mixpanel.init(
  process.env.REACT_APP_MIXPANEL_KEY || '89fcd40581da1c37128b37675c8d03d7'
)
const scoops = Scoops('scoops-api-key', mixpanel, {
  brand: styleguide.colors.primary,
})

function track(event, data) {
  if (
    mixpanel &&
    typeof mixpanel === 'object' &&
    typeof mixpanel.track === 'function'
  ) {
    return mixpanel.track(event, data)
  }
}

class App extends Component {
  constructor() {
    super()
    this.goToProductHunt = this.goToProductHunt.bind(this)
    this.hideShip = this.hideShip.bind(this)
    this.state = {
      renderShip: false,
      showShip: false,
    }

    track('Page View', {
      Page: 'Landing Page',
    })
  }

  async goToProductHunt(event) {
    track('Clicked Sign Up Button', {
      Event: event,
    })
    return scoops
      .survey(event)
      .catch(scoop => {
        track('Triggered Product Hunt', {
          Event: event,
          'Saw Survey': false,
        })
        this.setState({ renderShip: true })
        setTimeout(() => {
          this.setState({ showShip: true })
        }, 0)
      })
      .then(scoop => {
        track('Triggered Product Hunt', {
          Event: event,
          'Saw Survey': true,
        })
        this.setState({ renderShip: true })
        setTimeout(() => {
          this.setState({ showShip: true })
        }, 0)
      })
  }

  hideShip() {
    this.setState({ showShip: false })
    setTimeout(() => {
      this.setState({ renderShip: false })
    }, 400)
  }

  render() {
    return (
      <div
        css={`
          max-width: 100%;
          overflow: hidden;
        `}>
        <Topbar justify="space-between">
          <Row
            justify="start"
            css={`
              ${styleguide.layouts.content};
              padding-top: ${styleguide.spacing.s};
              padding-bottom: ${styleguide.spacing.s};
            `}>
            <a href="#scoops">
              <img
                alt="scoops"
                src="./scoops-logo.svg"
                css={`
                  width: 125px;
                  position: relative;
                `}
              />
            </a>
          </Row>
        </Topbar>
        {this.state.renderShip && (
          <Ship offClick={this.hideShip} shown={this.state.showShip} />
        )}

        <Sections.Hero onCta={this.goToProductHunt} />
        <Divider inline />
        <Sections.GetActionableData />
        <Divider inline contentWide />
        <Sections.KeepYourUsersHappy />
        <Divider inline contentWide />
        <Sections.LearnOverTime />
        <Divider inline />
        <Sections.HowItWorks />
        <Divider inline />
        <Layout patterned>
          <Column align="start">
            <Text
              hero
              serif
              bold
              css={`
                margin-bottom: 20px;
                ${styleguide.mobile(
                  css`
                    font-size: 4rem;
                  `
                )};
              `}>
              Get Answers.
            </Text>
            <Text subtext pt>
              Let’s create a world where users work with businesses to determine
              how to build the future.
            </Text>
            <Button
              id="click-sign-up-final"
              primary
              onClick={() => this.goToProductHunt('click-sign-up-final')}
              css={`
                margin-top: 30px;
              `}>
              Sign Up For Updates
            </Button>
          </Column>
        </Layout>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js